import { Component, OnInit } from '@angular/core';
import { General_Config } from '../General_Config';
import { CommonFunctionsService } from '../common-functions.service';
import { RestApiService } from '../rest-api.service';
import { ModalController, AlertController } from '@ionic/angular';
import { OrderdetailPage } from '../orderdetail/orderdetail.page';

@Component({
  selector: 'app-order',
  templateUrl: './order.page.html',
  styleUrls: ['./order.page.scss'],
})
export class OrderPage implements OnInit {
  page: number = 1;
  data: any = [];
  qry: string = null;
  isLoading: boolean = true;
  isChangingStatus: boolean = false;
  isProcessing: boolean = false;
  order_by: string = 'uo.ID-desc';
  disableLoader: boolean = false;
  order_type: string = 'placed';
  constructor(public alertController: AlertController, public modalController: ModalController, public restApi: RestApiService, public commonFunctions: CommonFunctionsService) {
    General_Config.active_page = 'Order';
  }

  ngOnInit() {
    this.loadData(null);
  }

  loadData(event) {
    if (event == null) {
      this.disableLoader = false;
      this.page = 1;
    } else {
      this.page = this.page + 1;
    }
    this.restApi.get('shopadmin_order/' + this.order_type + '/' + this.qry + '/' + this.order_by + '/' + this.page).subscribe((data: any) => {
      this.isLoading = false;
      if (data['code'] == 200) {
        if (event == null) {
          this.data = data['data'];
          if (data['data'].length < 20) {
            this.disableLoader = true;
          }
        } else {
          Array.prototype.push.apply(this.data, data['data']);
        }
        if (event != null) {
          if (data['data'].length < 20) {
            this.disableLoader = true;
          } else {
            event.target.complete();
          }
        }
      } else {
        if (event == null) {
          this.data = [];
        }
        this.disableLoader = true;
      }
    }, (error: any) => {
      this.isLoading = false;
      this.commonFunctions.presentAlertConfirm('Information', error);
    });
  }

  async changeStatus(code, status) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: "Confirmation",
      message: "Do you want to change the sataus as " + status + "?",
      buttons: [
        {
          text: 'No',
          handler: () => {
            console.log('Confirm No');
          }
        },
        {
          text: 'Yes',
          handler: () => {
            this.isChangingStatus = true;
            this.restApi.put('change_order_status', { code: code, status: status }).subscribe((data: any) => {
              this.isChangingStatus = false;
              if (data['code'] == 200) {
                this.loadData(null);
              }
              this.commonFunctions.presentAlertConfirm('Information', data['message']);
            }, (error: any) => {
              this.isChangingStatus = false;
              this.commonFunctions.presentAlertConfirm('Information', error);
            });
          }
        }
      ]
    });
    await alert.present();
  }

  async orderDelivered(code) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Delivery code',
      inputs: [
        {
          name: 'code',
          type: 'text',
          placeholder: '6 digit code'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Complete',
          handler: (input) => {
            if (input.code !== '') {
              this.isChangingStatus = true;
              this.restApi.put('delivered_order', { code: code, delivery_code: input.code }).subscribe((data: any) => {
                this.isChangingStatus = false;
                if (data['code'] == 200) {
                  this.loadData(null);
                }
                this.commonFunctions.presentAlertConfirm('Information', data['message']);
              }, (error: any) => {
                this.isChangingStatus = false;
                this.commonFunctions.presentAlertConfirm('Information', error);
              });
            } else {
              return false;
            }
          }
        }
      ]
    });
    await alert.present();
  }

  async rejectOrder(code) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Reject reason',
      inputs: [
        {
          name: 'reason',
          type: 'textarea',
          placeholder: 'Reason'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Reject',
          handler: (input) => {
            if (input.reason !== '') {
              this.isLoading = true;
              this.restApi.put('reject_order', { code: code, reject_reason: input.reason }).subscribe((data: any) => {
                this.isLoading = false;
                if (data['code'] == 200) {
                  this.loadData(null);
                }
                this.commonFunctions.presentAlertConfirm('Information', data['message']);
              }, (error: any) => {
                this.isLoading = false;
                this.commonFunctions.presentAlertConfirm('Information', error);
              });
            } else {
              return false;
            }
          }
        }
      ]
    });
    await alert.present();
  }

  async editOrder(code) {
    const modal = await this.modalController.create({
      component: OrderdetailPage,
      cssClass: '',
      componentProps: { property: code }
    });
    modal.onDidDismiss().then(data => {
      if (data.data && data.data.success && data.data.success == true) {
        this.loadData(null);
      }
    });
    return await modal.present();
  }
}
